/** @file The import's REST ports over the shared api client, with the caller's `confirmed` wait. */
import { api } from '../api/api';
import type { ImportPorts } from './importTypes';

/** `confirmed` resolves once the editor's document reached a rev; a new project has no session and resolves at once. */
export const restPorts = (confirmed: (rev: number) => Promise<void>): ImportPorts => ({
  createProject: (name) => api.createProject(name),
  uploadImage: (projectId, name, png) => api.uploadImage(projectId, name, png),
  applyCommands: (projectId, batch) => api.applyCommands(projectId, batch),
  confirmed,
});
